export default __webpack_public_path__ + "static/icon-2d98c87d5e5bac9f8d6607c7c578a18d.png";